import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { makeStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Moment from "moment";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";
import Modal_Frame from "../Modal_Frame";
import CreateActivities from "../../crm/Activities/CreateActivities";
import CreateNotes from "../../crm/Activities/CreateNotes";
import UseFetchData from "../../../hooks/UseFetchData";
import styles from "../../../assets/jss/material-dashboard-react/components/tasksStyle.js";
import { DeviceHubOutlined } from "@material-ui/icons";


const todate = new Date()
const Dfromdate = todate.getFullYear() + '/04/01';
const fromdate = new Date(todate.getFullYear(), todate.getMonth(), todate.getDate() - 60);

const useStyles = makeStyles(styles);

export default function Tasks(props) {
  const classes = useStyles();
  const [isOpen, setOpen] = useState(false);
  const [isNoteOpen, setNoteOpen] = useState(false);
  const [OpenModel, setOpenModel] = useState(false);
  const [ActivityID, setActivityID] = useState('');
  const [UserID, setUserID] = useState(sessionStorage.UID);
  const [FromDate, setFromDate] = useState(Dfromdate);
  const [ToDate, setToDate] = useState(todate.toISOString());
  const [ActivityType, setActivityType] = useState('');
  const [NoteID, setNoteID] = useState('');
  const [ActivityCategory, setActivityCategory] = useState([]);
  const [NotesTitle, setNotesTitle] = useState([]);
  const [Description, setDescription] = useState([]);
  const [AccountName, setAccountName] = useState([]);
  const [ActivityDate, setActivityDate] = useState([]);
  const [IDs, setIDs] = useState([]);
  const [responseDtls, fetchDtlsData] = UseFetchData();

  const [checked, setChecked] = React.useState([...props.checkedIndexes]);

  const handleToggle = (value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const { tasksIndexes, tasks, rtlActive, value } = props;

  const tableCellClasses = classnames(classes.tableCell, {
    [classes.tableCellRTL]: rtlActive,
  });

  const AddNewClick = (ID, ACType) => {
    // debugger;
    console.log(tasksIndexes);
    if (value === 0) {
      setOpen(true);
      setActivityID(ID);
      setActivityType(ACType);
      // setAMode(AMode);
    }
    else if (value === 1) {
      // setOpenModel(true);
      setNoteOpen(true);
      setNoteID(ID)
    }
  }

  const PopulateData = () => {
    // debugger;
    var bodyFormData = new FormData();
    bodyFormData.append("UserID", UserID);
    bodyFormData.append("FinacialDate", '');
    bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
    bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
    fetchDtlsData("Dashboard/View", bodyFormData);
  }

  useEffect(() => {
    if (tasks !== undefined && tasks.length > 0) {
      if (value === 0) {
        var array = [];
        var IDArray = [];
        var CatArray = [];
        var AccNArray = [];
        var ADArray = [];
        for (var i = 0; i < tasks.length; i++) {
          var act = tasks[i].Description;
          array.push(act);
          var actID = tasks[i].ActivityID;
          IDArray.push(actID);
          var actCat = tasks[i].ActivityCategory;
          CatArray.push(actCat);
          var actAcc = tasks[i].AccountName;
          AccNArray.push(actAcc);
          var actDate = tasks[i].ActivityDate;
          ADArray.push(actDate);
        }
        setDescription(array);
        setIDs(IDArray);
        setActivityCategory(CatArray);
        setAccountName(AccNArray);
        setActivityDate(ADArray);
      }
      else if (value === 1) {
        var array = [];
        var IDArray = [];
        var NTarray = [];
        for (var i = 0; i < tasks.length; i++) {
          var note = tasks[i].Notes;
          array.push(note);
          var ID = tasks[i].NotesID;
          IDArray.push(ID);
          var noteT = tasks[i].NotesTitle;
          NTarray.push(noteT);
        }
        setDescription(array);
        setIDs(IDArray);
        setNotesTitle(NTarray);
      }
    }
  }, [tasks]);

  return (
    <Table className={classes.table}>
      <TableBody>
        {tasksIndexes.map((value) => (
          <TableRow key={value} className={classes.tableRow}>

            <TableCell className={tableCellClasses}>{NotesTitle[value]}</TableCell>
            <TableCell className={tableCellClasses}>{AccountName[value]}</TableCell>
            <TableCell className={tableCellClasses}>{Description[value]}</TableCell>
            <TableCell className={tableCellClasses}>{ActivityDate[value]}</TableCell>
            <TableCell className={classes.tableActions}>
              <Tooltip
                id="tooltip-top"
                title="Edit Task"
                placement="top"
                classes={{ tooltip: classes.tooltip }}
              >
                <IconButton
                  aria-label="Edit"
                  className={classes.tableActionButton}
                  onClick={() => { AddNewClick(IDs[value], ActivityCategory[value]); }}
                >
                  <Edit
                    className={
                      classes.tableActionButtonIcon + " " + classes.edit
                    }
                  />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
      <Modal_Frame
        title="Activity Details"
        maxWidth="md"
        isOpen={isOpen}
        setOpen={setOpen}
      >
        <CreateActivities
          setOpen={setOpen}
          ActivityID={ActivityID}
          RefDocumentID={UserID}
          ActivityType={ActivityType}
          DisableUpdate={false}
          DisableComplete={false}
          DisableDelete={false}
          DisablePage={false}
          pageName={"Dash"}
          // PopulateData={PopulateData}
          Populate={() => props.Populate('')}
          DisableCustomer={false}
          DisableContact={false}
          DisableRefDoc={false}
        />
      </Modal_Frame>

      <Modal_Frame
        title="Note Details"
        maxWidth="xs"
        // isOpen={OpenModel}
        // setOpen={setOpenModel}
        isOpen={isNoteOpen}
        setOpen={setNoteOpen}
      >
        <CreateNotes
          setNoteOpen={setNoteOpen}
          RefDocumentID={UserID}
          NoteID={NoteID}
          pageName={"Dash"}
          // PopulateData={PopulateData}
          Populate={() => props.Populate('')}
        />
      </Modal_Frame>
    </Table>
  );
}

Tasks.propTypes = {
  tasksIndexes: PropTypes.arrayOf(PropTypes.number),
  tasks: PropTypes.arrayOf(PropTypes.node),
  rtlActive: PropTypes.bool,
  checkedIndexes: PropTypes.array,
};
